ApiError = require 'network/api-error'
HandleJoinRequestComponent = require 'views/enterprise/dashboard/handle-join-request-component'
BoardOfTeamComponent = require 'views/enterprise/dashboard/board-of-team-component'
BulkActionsComponent = require 'views/enterprise/dashboard/bulk-actions-component'
Controller = require 'controller'
FiltersComponent = require 'views/enterprise/dashboard/filters-component'
FilterPopOverButtonComponent = require 'views/enterprise/dashboard/filters/popover-button-component'
GroupListPopOverComponent = require 'views/enterprise/dashboard/group-list-popover-component'
JoinRequestMembersComponent = require 'views/enterprise/dashboard/join-request-members-component'
MainContentComponent = require 'views/enterprise/dashboard/main-content-component'
ListComponent = require 'views/enterprise/dashboard/list-component'
ListHeaderComponent = require 'views/enterprise/dashboard/list-header-component'
MemberItemComponent = require 'views/enterprise/dashboard/member-item-component'
InfiniteScroll = require 'views/lib/infinite-scoll'
ItemList = require 'views/enterprise/dashboard/item-list'
PopOver = require 'views/lib/pop-over'
BulkActionProgressDisplay = require 'views/lib/bulk-action-progress-display'
SingleListPopOverComponent = require 'views/enterprise/dashboard/single-list-popover-component'
PopOverTeamItemComponent = require 'views/enterprise/dashboard/popover-team-item-component'
SingleLineFilterComponent = require 'views/enterprise/dashboard/filters/single-line-filter-component'
ProgressDisplayComponent = require 'views/enterprise/dashboard/bulk-actions/progress-component/display-component'
TeamListComponent = require 'views/enterprise/dashboard/team-list-component'
BulkActionsTeamOptionsListComponent = require 'views/enterprise/dashboard/bulk-actions/team-options-list-component'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
SidebarComponent = require 'views/enterprise/dashboard/sidebar-component'
TabbedPaneView = require 'views/internal/tabbed-pane-view'
TeamItemComponent = require 'views/enterprise/dashboard/team-item-component'
TeamOfMemberComponent = require 'views/enterprise/dashboard/team-of-member-component'
Util = require 'lib/util'
React = require 'react'
View = require 'view'
$ = require 'jquery'
l = require 'lib/localize'
mixin = require 'lib/mixin'
bulkActions = require 'views/enterprise/dashboard/bulk-actions/bulk-actions'
renderableItems = require 'views/enterprise/dashboard/renderable-items'
template = require 'views/templates/enterprise_detail'
Promise = require 'bluebird'
_ = require 'underscore'

{ LOADED, LOADING_NEW, LOADING_NEXT, LOADING_ERROR } =
  ListComponent.LOADING_STATES

module.exports = class EnterpriseAdminDashboardView extends View
  mixin TabbedPaneView, @

  initialize: ({ initialTab }) ->
    super

    @itemLists =
      members: new ItemList.Member(@model)
      teams: new ItemList.Team(@model)

    @selectedTab = initialTab ? 'members'

    @_initLoadingIndicators()

    @listenTo @model.organizationList, 'add', (newOrg) =>
      @itemLists.teams.add(newOrg)
      if @selectedTab == 'teams'
        @_loadUserTypes()

    @listenTo @model, 'change:joinRequests', @renderDynamic

  remove: ->
    @infiniteScroll?.destroy()

  _initTab: ->
    PopOver.hide()
    _.invoke(@itemLists, 'resetState')
    @infiniteScroll.reset()
    if @selectedTab == 'teams'
      @_loadJoinRequests()

  _initInfiniteScroll: ->
    @infiniteScroll = new InfiniteScroll @listRoot
    @infiniteScroll.on 'nearEnd', =>
      @getActiveList().loadNextPage()

  getActiveList: ->
    @itemLists[@selectedTab]

  render: ->
    @$el.html template
      displayName: @model.get('displayName')
      enforcesSso: @model.get('prefs').ssoOnly

    @_initTab() if @tabChanged

    @renderStatic()
    @renderDynamic()

    @_initInfiniteScroll()
    @_loadUserTypes()

    @tabChanged = false

    @

  _renderSection: (root, selector, component) ->
    @$(selector).append(root)
    el = React.createElement ReactRootComponent, {}, component
    ReactDOM.render(el, root)

  renderStatic: ->
    @reactRoot ?= document.createElement('div')
    @_renderSection(@reactRoot, '.js-content', @getMainContentComponent())

  _renderMembersTabOnlySections: ->
    @$('.js-filters-content').empty()
    @$('.js-bulk-actions-content').empty()

    return unless @selectedTab == 'members'

    @filtersRoot ?= document.createElement('div')
    @_renderSection(@filtersRoot, '.js-filters-content', @getFiltersComponent())

    if @loadingState != LOADING_NEW
      @bulkActionsRoot ?= document.createElement('div')
      @_renderSection(@bulkActionsRoot, '.js-bulk-actions-content', @getBulkActionsComponent())

  renderDynamic: ->
    @sidebarRoot ?= document.createElement('div')
    @_renderSection(@sidebarRoot, '.js-sidebar-content', @getSidebarComponent())

    @listHeaderRoot ?= document.createElement('div')
    @_renderSection(@listHeaderRoot, '.js-list-header-content', @getListHeaderComponent())

    @listRoot ?= document.createElement('div')
    @_renderSection(@listRoot, '.js-list-content', @getListComponent())

    @_renderMembersTabOnlySections()

  rerender: ->
    @renderDynamic()

  bulkAddToTeam: (team, members, afterEach) ->
    afterEachWrapper = (member, status, membership) =>
      afterEach()
      if status == 'add:added'
        team.addMembership(membership)
        member.orgAdded(team)

    bulkActions.addToTeam(team, members, afterEachWrapper, { concurrency: 5 })

  bulkRemoveFromTeam: (team, members, removeFromBoards, afterEach) ->
    afterEachWrapper = (member, status) =>
      afterEach()
      if status == 'remove:removed'
        membership = team.getMembershipFor(member.toBackbone())
        team.removeMembership(membership)
        member.orgRemoved(team)

    bulkActions.removeFromTeam(team, members, afterEachWrapper, { removeFromBoards, concurrency: 5 })

  bulkDeactivateFromTeam: (team, members, afterEach) ->
    afterEachWrapper = (member, status) =>
      afterEach()
      if status == 'deactivate:deactivated'
        team.setOnMembership(member.toBackbone(), { deactivated: true })
        member.orgDeactivated(team)

    bulkActions.deactivateFromTeam(team, members, afterEachWrapper, { concurrency: 5 })

  displayBulkTeamOptions: (el, team) ->
    PopOver.pushView
      elem: el
      alignRight: true
      getViewTitle: -> l(['view title', 'team bulk actions options'], { teamDisplayName: team.displayName }, { raw: true })
      reactElement: React.createElement BulkActionsTeamOptionsListComponent,
        team: team
        getSelectedMembers: @itemLists.members.selectedItems()
        eventHandlers:
          runBulkActionAdd: (members) =>
            progressDisplay = new BulkActionProgressDisplay(el, team.toBackbone().get('displayName'), @model.get('displayName'),
              members.length, 'add')
            @bulkAddToTeam team.toBackbone(), members, ->
              progressDisplay.incrementProcessed()
            .then (results) =>
              progressDisplay.done(results)
              @rerender()
          runBulkActionRemove: (members, removeFromBoards) =>
            progressDisplay = new BulkActionProgressDisplay(el, team.toBackbone().get('displayName'), @model.get('displayName'),
              members.length, 'remove')
            @bulkRemoveFromTeam team.toBackbone(), members, removeFromBoards, ->
              progressDisplay.incrementProcessed()
            .then (results) =>
              progressDisplay.done(results)
              @rerender()
          runBulkActionDeactivate: (members) =>
            progressDisplay = new BulkActionProgressDisplay(el, team.toBackbone().get('displayName'), @model.get('displayName'),
              members.length, 'deactivate')
            @bulkDeactivateFromTeam team.toBackbone(), members, ->
              progressDisplay.incrementProcessed()
            .then (results) =>
              progressDisplay.done(results)
              @rerender()
        key: "bulk-add-teams"

  getMainContentComponent: ->
    React.createElement MainContentComponent,
      selectedTab: @selectedTab
      clearSearchValue: @tabChanged || @resetSearch
      onSearchTermChange: @search.bind(@)

  search: (term) ->
    @getActiveList().updateFilter('search', term)

  _loadUserTypes: ->
    @model.loadUserTypes().then => @rerender()

  _loadJoinRequests: ->
    @model.loadJoinRequests().then => @rerender()

  _initLoadingIndicators: ->
    @_setLoadingState LOADING_NEW
    for itemList in _.values(@itemLists)
      @listenTo itemList, 'loading', @onListLoading
      @listenTo itemList, 'loadingNext', @onListLoadingNext
      @listenTo itemList, 'loaded', @onListLoaded
      @listenTo itemList, 'loadError', @onListLoadingError

  _setLoadingState: (state) ->
    if state in [LOADED, LOADING_NEW, LOADING_NEXT, LOADING_ERROR]
      @loadingState = state
      @rerender()

  onListLoading: ->
    @_setLoadingState LOADING_NEW

  onListLoadingNext: ->
    @_setLoadingState LOADING_NEXT

  onListLoaded: ->
    @_setLoadingState LOADED
    @infiniteScroll.reset()

  onListLoadingError: ->
    @_setLoadingState LOADING_ERROR
    @infiniteScroll.reset()

  onTeamsOfMemberPopoverClick: (el, renderableMember) ->
    return unless renderableMember.organizations.length > 0

    groups =
      active: []
      deactivated: []

    for org in renderableMember.organizations
      team = new renderableItems.Team(org)
      group = if org.getMembershipFor(renderableMember.toBackbone()).deactivated
        'deactivated'
      else
        'active'
      groups[group].push(team)

    PopOver.toggle
      elem: el
      getViewTitle: -> l(['view title', 'teams'])
      reactElement: React.createElement GroupListPopOverComponent,
        modelName: 'teams'
        items: groups
        itemComponent: TeamOfMemberComponent
        key: "#{ renderableMember.username }-teams"

    return

  onBoardsOfTeamPopoverClick: (el, renderableTeam) ->
    return unless renderableTeam.boards.length > 0

    PopOver.toggle
      elem: el
      getViewTitle: -> l(['view title', 'boards'])
      reactElement: React.createElement SingleListPopOverComponent,
        modelName: 'boards'
        items: renderableTeam.boards.map (board) ->
          new renderableItems.Board(board)
        itemComponent: BoardOfTeamComponent
        key: "#{ renderableTeam.name }-boards"

    return

  onSelectMemberClick: (item, { selectRange }) ->
    @getActiveList().itemSelected(item, selectRange)
    # updates BulkActionsComponent to display the new count
    @rerender()

  getListComponent: ->
    if @selectedTab == 'members'
      React.createElement ListComponent,
        loadingState: @loadingState
        items: @getActiveList().items()
        itemEventHandlers:
          onSelectCheckboxClick: @onSelectMemberClick.bind(@)
          onPopoverClick: @onTeamsOfMemberPopoverClick
        itemComponent: MemberItemComponent
    else
      React.createElement TeamListComponent,
        joinRequests: @model.get('joinRequests')
        items: @getActiveList().items()
        onPopoverClick: @onBoardsOfTeamPopoverClick
        attemptedToLoadUserTypes: @model.attemptedToLoadUserTypes
        availableLicenses: @model.getAvailableLicenses()
        onViewNewBillableMembers: (el, joinRequest) =>
          PopOver.toggle
            elem: el
            getViewTitle: -> l(['view title', 'new-billable-members'])
            reactElement: React.createElement JoinRequestMembersComponent,
              members: joinRequest.transferability.newBillableMembers
              key: "join-request-new-billable-members-#{ joinRequest.date }"
        onViewUntransferredMembers: (el, joinRequest) =>
          PopOver.toggle
            elem: el
            getViewTitle: -> l(['view title', 'untransferred-members'])
            reactElement: React.createElement JoinRequestMembersComponent,
              members: joinRequest.transferability.untransferredMembers
              key: "join-request-untransferred-members-#{ joinRequest.date }"
        onDecline: (el, joinRequest) =>
          PopOver.toggle
            elem: el
            getViewTitle: -> l(['view title', 'decline-add-to-enterprise'])
            reactElement: React.createElement HandleJoinRequestComponent,
              acceptOrDecline: 'decline'
              onClick: =>
                @model.declineJoinRequest(joinRequest)
                .then ->
                  PopOver.hide()
              key: "decline-join-request-#{ joinRequest.date }"
        onAccept: (el, joinRequest) =>
          PopOver.toggle
            elem: el
            getViewTitle: -> l(['view title', 'confirm-add-to-enterprise'])
            reactElement: React.createElement HandleJoinRequestComponent,
              acceptOrDecline: 'accept'
              currentTotal: @_getEnterpriseMembersCount()
              newBillableMembersCount: joinRequest.transferability.newBillableMembers.length
              max: @_getMaxMembers()
              onClick: =>
                @model.acceptJoinRequest(joinRequest)
                .catch ApiError, =>
                  @_loadJoinRequests()
                .then ->
                  PopOver.hide()
              key: "accept-join-request-#{ joinRequest.date }"

  getSidebarComponent: ->
    React.createElement SidebarComponent,
      pendingRequestsCount: @model.get('joinRequests').length
      userTypesLoaded: @model.get('userTypes')?
      teamsCount: @itemLists.teams.totalLength()
      membersCount: @_getTotalUsersCount()
      enterpriseMembersCount: @_getEnterpriseMembersCount()
      outsideCollaboratorsCount: @_getOutsideCollaboratorsCount()
      ssoUsersCount: @_getSsoUsersCount()
      enterpriseMaxMembers: @_getMaxMembers()
      deactivatedCount: @_getDeactivatedCount()
      nearMaxMembers: @_isNearMaxMembers()
      exceedingMaxMembers: @_isExceedingMaxMembers()
      selectedTab: @selectedTab
      onSidebarTabClick: (newTab) =>
        @selectedTab = newTab
        @tabChanged = true

        Controller.navigate(Controller.getEnterpriseAdminDashboardUrl(@model, newTab))

        @render()

  getBulkActionsComponent: ->
    React.createElement BulkActionsComponent,
      count: @itemLists.members.selectedItemsLength()
      totalCount: @itemLists.members.lengthOfSearch()
      onTeamsPopoverClick: (el) =>
        return unless @model.organizationList.models.length > 0

        PopOver.toggle
          elem: el
          maxWidth: 410
          alignRight: true
          getViewTitle: -> l 'add or remove from team'
          reactElement: React.createElement SingleListPopOverComponent,
            modelName: 'teams'
            items: @model.organizationList.map (org) ->
              new renderableItems.Team(org)
            itemComponent: PopOverTeamItemComponent
            itemEventHandlers:
              onClick: (team) =>
                @displayBulkTeamOptions(el, team)
            key: "bulk-teams"

        return
      hasTeams: @itemLists.teams.totalLength() > 0
      allItemsAreSelected: @itemLists.members.selectedItemsLength() == @itemLists.members.lengthOfSearch()
      allVisibleItemsAreSelected: @itemLists.members.selectedItemsLength() >= @itemLists.members.items().length
      onSelectAll: =>
        @itemLists.members.selectAll()
        @rerender()
      onClearAll: =>
        @itemLists.members.deselect()
        @rerender()
      hasSelectedItems: @itemLists.members.selectedItemsLength() > 0

  getListHeaderComponent: ->
    itemList = @getActiveList()

    React.createElement ListHeaderComponent,
      isFiltering: @getActiveList().getActiveFilters().length > 0
      title: Util.capitalize(@selectedTab)
      count: itemList.lengthOfSearch()
      allCount: itemList.totalLength()
      error: @loadingState == LOADING_ERROR
      isSortable: @selectedTab == 'members'
      sortField: @getActiveList().getSortField?()
      sortOrder: @getActiveList().getSortOrder?()
      onSortClick: (el) =>
        PopOver.toggle
          elem: el
          getViewTitle: -> l(['view title', 'sort by'])
          reactElement: React.createElement SingleListPopOverComponent,
            items: [
              { name: 'A-Z',  sortField: 'fullName', sortOrder: 'ascending' }
              { name: 'Z-A', sortField: 'fullName', sortOrder: 'descending' }
              { name: 'least-recently-active',  sortField: 'dateLastActive', sortOrder: 'ascending' }
              { name: 'most-recently-active', sortField: 'dateLastActive', sortOrder: 'descending' }
            ]
            itemComponent: SingleLineFilterComponent
            itemEventHandlers:
              onClick: ({ sortField, sortOrder }) =>
                PopOver.hide()
                @getActiveList().sort(sortField, sortOrder)
                @rerender()
            itemInlineButtons:
              isActive: ({ sortField, sortOrder })=>
                @getActiveList().getSortField() == sortField && \
                  @getActiveList().getSortOrder() == sortOrder
            key: "sort-by-activity"

        return
      onShowAll: =>
        @search()
        @resetSearch = true
        @_clearFiltersExceptSearch()
        @getActiveList().clearFilter('search')
        @renderStatic()
        @resetSearch = false

  _getTotalUsersCount: ->
    @model.get('userTypes')?.all

  _getEnterpriseMembersCount: ->
    @model.get('userTypes')?.member

  _getDeactivatedCount: ->
    @model.get('userTypes')?.none

  _getOutsideCollaboratorsCount: ->
    @model.get('userTypes')?.collaborator

  _getSsoUsersCount: ->
    @model.get('userTypes')?.saml

  _getMaxMembers: ->
    @model.getPref('maxMembers')

  _isNearMaxMembers: ->
    max = @_getMaxMembers()
    return false if !max?
    count = @_getEnterpriseMembersCount()
    # “near” means < 5% capacity remaining, or 20 seats, whichever is less
    max - count <= Math.min(Math.ceil(max * 0.05), 20)

  _isExceedingMaxMembers: ->
    max = @_getMaxMembers()
    max? && max < @_getEnterpriseMembersCount()

  # this doesn't clear search because the grouping of the
  # buttons in the ui suggests that Clear Filters will not operate on it
  _clearFiltersExceptSearch: ->
    PopOver.hide()
    for filter in ['teams', 'userType', 'hasTransferred']
      @getActiveList().clearFilter(filter)

  getFiltersComponent: ->
    filterPopoverParams = (filterName, el, { items, itemComponent, optionIsActive, onFilterOptionClick }) =>
      isActive = filterName in @getActiveList().getActiveFilters()

      elem: el
      alignRight: true
      getViewTitle: -> l(['view title', filterName])
      hideHeader: true
      displayType: 'filter-popover'
      reactElement: React.createElement SingleListPopOverComponent,
        modelName: filterName
        isActive: isActive
        buttonData: if isActive
          componentClass: FilterPopOverButtonComponent
          onClick: =>
            PopOver.hide()
            @getActiveList().clearFilter(filterName)
            @rerender()
        items: items
        itemComponent: itemComponent
        itemInlineButtons:
          isActive: optionIsActive
        itemEventHandlers:
          onClick: onFilterOptionClick
        key: "#{ filterName }-filter"

    React.createElement FiltersComponent,
      hasTeams: @itemLists.teams.totalLength() > 0
      activeFilters: @getActiveList().getActiveFilters()
      clickHandlers:
        team: (el) =>
          return unless @model.organizationList.models.length > 0

          makeParams = => filterPopoverParams 'teams', el,
            items: @model.organizationList.map (org) ->
              new renderableItems.Team(org)
            itemComponent: PopOverTeamItemComponent
            onFilterOptionClick: (team) =>
              @getActiveList().toggleFilter('teams', team.id)
              @rerender()
              PopOver.load(makeParams())
            optionIsActive: (team) =>
              team.id in @getActiveList().getFilterValueMap()['teams']

          PopOver.toggle(makeParams())

          return
        userType: (el) =>
          makeParams = => filterPopoverParams 'userType', el,
            items: [
              { name: 'member' }
              { name: 'collaborator' }
              { name: 'saml' }
              { name: 'none' }
            ]
            itemComponent: SingleLineFilterComponent
            onFilterOptionClick: (userType) =>
              @getActiveList().toggleFilter('userType', userType.name)
              @rerender()
              PopOver.load(makeParams())
            optionIsActive: (userType) =>
              userType.name in @getActiveList().getFilterValueMap()['userType']

          PopOver.toggle(makeParams())

          return
        hasTransferred: (el) =>
          makeParams = => filterPopoverParams 'hasTransferred', el,
            items: [
              { name: 'transferred' }
              { name: 'not-transferred' }
            ]
            itemComponent: SingleLineFilterComponent
            optionIsActive: (option) =>
              currentValue = @getActiveList().getFilterValueMap()['hasTransferred']
              return false unless currentValue?
              if option.name == 'transferred'
                currentValue
              else
                !currentValue
            onFilterOptionClick: (clicked) =>
              currentValue = @getActiveList().getFilterValueMap()['hasTransferred']

              if !currentValue?
                @getActiveList().updateFilter('hasTransferred', clicked.name == 'transferred')
              else
                clickedOnAlreadyActive = if currentValue
                    clicked.name == 'transferred'
                  else
                    clicked.name == 'not-transferred'

                if clickedOnAlreadyActive
                  @getActiveList().clearFilter('hasTransferred')
                else
                  @getActiveList().updateFilter('hasTransferred', clicked.name == 'transferred')

              @rerender()
              PopOver.load(makeParams())

          PopOver.toggle(makeParams())

          return
        clear: =>
          @_clearFiltersExceptSearch()
          @rerender()



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/enterprise-admin-dashboard-view.coffee